module.exports = __webpack_public_path__ + "img/inncash-comunity-call-button.5003c83c.webp";